import { render, staticRenderFns } from "./SettingsApi.vue?vue&type=template&id=528da23b"
import script from "./SettingsApi.vue?vue&type=script&lang=js"
export * from "./SettingsApi.vue?vue&type=script&lang=js"
import style0 from "./SettingsApi.vue?vue&type=style&index=0&id=528da23b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports